import { dateFormat } from 'common/helpers/dateHelper';

import Notes from './details/Notes';
import PaymentMethod from './details/PaymentMethod';

const ReservationDetail = (props) => {
  const { reservation, settings } = props;
  return (
    <div className="c7-order__customer-detail">
      <h4>Reservation information</h4>
      <div>
        <span>
          <strong>Reservation Information</strong>
          <br />
          Reservation Number: {reservation.reservationNumber}
          <br />
          Reservation Date: {dateFormat(reservation.reservationDate, settings)}
          <Status reservation={reservation} />
        </span>
        <Notes notes={reservation.notes} />
      </div>
      <div>
        <PaymentMethod reservation={reservation} />
      </div>
    </div>
  );
};

const Status = (props) => {
  const { reservation } = props;
  if (reservation.status === 'Cancelled') {
    return (
      <>
        <br />
        Status: {reservation.status}
      </>
    );
  }
  return null;
};

export default ReservationDetail;
